<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Lucille L Turfrey was born and raised in the Huon valley in southern Tasmania. Following tertiary education, Lucille became an art teacher. A change of vocation later found her engaged in youth ministries as a Salvation Army officer with a remit that included camping, congresses, leadership training and writing manuals for youth leaders, and also booklets on basic theology. Lucille was then appointed principal of the officer training college in southern Australia. International service found her involved in ministry in Scotland before being appointed to Russia, again as training principal. It is in retirement that Lucille has taken up pen and paintbrush to illustrate the truths, the principles and practice that have been her life’s focus, formula and foundation.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7ecda26a